export default {
  currentTime: state => state.player && state.player.currentTime ? state.player.currentTime() : 0,
  videoDuration: state => state.player && state.player.duration ? state.player.duration() : 0,
  notifications: state => state.notifications,
  video: state => state.video,
  languages: state => state.video.meta.languages || [],
  defaultLanguage: state => state.video.meta.defaultLanguage || 'de',
  infoKey: state => {
    if (!state.selection.tag) {
      return 'editor.blank.create.tag'
    }
    if (state.selection.tag && state.selection.waypoint) {
      return 'editor.blank.edit.waypoint'
    }
    if (state.selection.tag && state.selection.scene && !state.selection.waypoint) {
      return 'editor.scene.select'
    }
    return 'editor.default.message'
  },
  activeScene: (state) => {
    if (state.selection.tag && state.player && state.player.currentTime) {
      const currentTime = state.player.currentTime()
      return state.selection.tag.scenes.find(s => s.waypoints.find(w => w.time <= currentTime) && s.waypoints.find(w => w.time >= currentTime)) ||
             state.selection.tag.scenes.find(s => s.waypoints.length === 1 && s.waypoints[0].time <= currentTime)
    }
  },
  configuration: state => state.configuration,
  grid: state => state.grid,

  getAllTagsFiltered: (state) => (tagFilter) => {
    const tags = state.video.tags

    return tags.filter( tag => {
      return tagFilter.some( tf => {
        return tag.template === tf
      })
    }) 
  },

  allWaypoints: function (state) {
    const tags = state.video.tags

    const allWaypoints = tags.reduce((acc, tag) => {
      return [
        ...acc,
        ...tag.scenes
          .reduce((acc, scene) => {
            return [
              ...acc,
              ...scene.waypoints
                .reduce((acc, wp) => {
                  return [
                    ...acc, 
                    {
                      wp: wp,
                      tag: tag,
                      scene: scene,
                      time: wp.time,
                      isActive: true
                    }
                  ]
                }, [])
            ]
          }, [])
      ]
    }, [])

    return allWaypoints
  },

  getAllWaypointsByTags: (state, getters) => (tags) => {
    return getters.allWaypoints.filter( wp => {
      return tags.some(tag => {
        return tag === wp.tag.template
      })
    })
  },

  getAllWaypointsByTime: (state, getters) => (time) => {
    return getters.allWaypoints.filter( wp => {
      return parseFloat(wp.time.toFixed(2)) === parseFloat(time.toFixed(2))
    })
  },

  getAllWaypointsByTimeAndTags: (state, getters) => (time, tags) => {
    return getters.getAllWaypointsByTags(tags).filter( wp => {
      return parseFloat(wp.time.toFixed(2)) === parseFloat(time.toFixed(2))
    })
  },

  getAllWaypointsByTagId: (state, getters) => (tagId) => {
    return getters.allWaypoints.filter( wp => {
      return wp.tag.id === tagId
    })
  },

  allScenes: function (state) {
    const tags = state.video.tags

    const allScenes = tags.reduce((acc, tag) => {
      return [
        ...acc,
        ...tag.scenes
          .reduce((acc, scene) => {
            return [
              ...acc,
              {
                tag: tag,
                scene: scene,
              }
            ]
          }, [])
      ]
    }, [])

    return allScenes
  },

  getAllScenesByTags: (state, getters) => (tags) => {
    return getters.allScenes.filter( scene => {
      return tags.some(tag => {
        return tag === scene.tag.template
      })
    })
  },

  getKeyFramesTimes: (state, getters) => (filter) => {
    const allWaypoints = getters.getAllWaypointsByTags(filter)
    let keyFramesTimes = []

    keyFramesTimes = allWaypoints.reduce((acc, wp) => {
      return [...acc, wp.time]
    }, [])

    keyFramesTimes = [...new Set(keyFramesTimes)]

    return keyFramesTimes
  },

  getFrameRate: function (state) {
    if (!state.video.meta.frameRate) {
      return 24;
    }
    
    const frameRateValues = state.video.meta.frameRate && state.video.meta.frameRate.split('/')
    const frameRate = Math.round(parseFloat(frameRateValues[0]) / parseFloat(frameRateValues[1])) || 24

    return frameRate
  }
}
